import virtualScroll from '../../dispatcher/hoc/virtualScroll';
import NavigationBaseGrid from './NavigationBaseGrid';

import {
  TAB_KEY_EVENT_PROPS as TKEP
} from './Types';

export type TAB_KEY_EVENT_PROPS = TKEP;

class NavigationGrid extends NavigationBaseGrid {}

export default virtualScroll(NavigationGrid);

